import { ReactComponent as Logo } from "../../assets/rdc-logo-default.svg";
import { NAVROUTES } from "../../data/navRoutes";
import { NavLink } from "react-router";

import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../store";
import { authSlice } from "../../store/auth/index";
import { toggleNav, closeNav } from "../../store/navMobile";

import { CiDark } from "react-icons/ci";
import { HiMenu } from "react-icons/hi";
import { IoClose } from "react-icons/io5";

import styles from "./Header.module.css";
import { toggleMode } from "../../store/theme/theme";
import { FaSun } from "react-icons/fa";

export default function Header() {
  const dispatch = useDispatch<AppDispatch>();
  const { isMobile, isNavOpen } = useSelector(
    (state: RootState) => state.navMobile
  );

  const token = useSelector((state: RootState) => state.auth.token);

  const { lightMode } = useSelector((state: RootState) => state.themeSlice);

  function handelLogout() {
    dispatch(authSlice.actions.logout());
  }

  function handleToggleNav() {
    dispatch(toggleNav());
  }

  function handleCloseNav() {
    dispatch(closeNav());
  }

  return (
    <header>
      <div className={`${styles.conatiner} container`}>
        <div className={styles.logo}>
          <Logo />
        </div>

        {isMobile ? (
          <button
            className={styles.hamburger}
            onClick={handleToggleNav}
            aria-label="Close"
          >
            {isNavOpen ? <IoClose /> : <HiMenu />}
          </button>
        ) : (
          <nav>
            <ul className={styles.ul}>
              {NAVROUTES.map((route) => {
                if (token) {
                  if (route.text === "SignIn" || route.text === "SignUp") {
                    return null;
                  }
                } else {
                  if (route.text === "Profile" || route.text === "Logout") {
                    return null;
                  }
                }

                return route.text === "Logout" ? (
                  <li key={route.text}>
                    <button onClick={handelLogout} className={styles.logout}>
                      {route.text}
                    </button>
                  </li>
                ) : (
                  <li key={route.text}>
                    <NavLink
                      to={route.link || "/"}
                      className={({ isActive }) =>
                        isActive ? styles.active : ""
                      }
                    >
                      {route.text}
                    </NavLink>
                  </li>
                );
              })}
            </ul>
            <button
              className={styles.switch}
              onClick={() => dispatch(toggleMode())}
            >
              {!lightMode ? <CiDark /> : <FaSun />}
            </button>
          </nav>
        )}
      </div>

      {isMobile && (
        <div className={`${styles.mobileNav} ${isNavOpen ? styles.open : ""}`}>
          <nav>
            <ul>
              {NAVROUTES.map((route) => {
                if (token) {
                  if (route.text === "SignIn" || route.text === "SignUp") {
                    return null;
                  }
                } else {
                  if (route.text === "Profile" || route.text === "Logout") {
                    return null;
                  }
                }

                return route.text === "Logout" ? (
                  <li key={route.text + "buttonLogout"}>
                    <button
                      onClick={() => {
                        handelLogout();
                        handleCloseNav();
                      }}
                      className={styles.logout}
                    >
                      {route.text}
                    </button>
                  </li>
                ) : (
                  <li key={route.text + "buttonNavLink"}>
                    <NavLink
                      to={route.link || "/"}
                      className={({ isActive }) =>
                        isActive ? styles.active : ""
                      }
                      onClick={handleCloseNav}
                    >
                      {route.text}
                    </NavLink>
                  </li>
                );
              })}
            </ul>
            <button
              className={styles.switch}
              onClick={() => dispatch(toggleMode())}
            >
              {!lightMode ? <CiDark /> : <FaSun />}
            </button>
          </nav>
        </div>
      )}
    </header>
  );
}
